var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-w-full tw-flex tw-text-[#1F2229] tw-pt-10"},[_c('div',{staticClass:"tw-flex tw-flex-col tw-gap-10 tw-grow tw-bg-white tw-rounded-2xl"},[_c('PortfolioSelectWrapper'),_vm._v(" "),_c('BenchmarkSelectWrapper'),_vm._v(" "),_c('OptimizedProposedSelectWrapper'),_vm._v(" "),_c('AdvisorCoreOptions')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }